module.exports = __webpack_public_path__ + "img/Thunderstorm.a6a082eb.png";